import { useEffect } from "react";
import axios from "../lib/axios.js";
import { useUserStore } from "../stores/useUserStores";

export const useAuthRefresh = () => {
  useEffect(() => {
    let active = true;

    const restoreSession = async () => {
      try {
        const profile = await axios.get("/auth/profile");
        if (active) {
          useUserStore.setState({
            user: profile.data.user || profile.data,
            checkingAuth: false,
          });
        }
      } catch (profileError) {
        try {
          await axios.post("/auth/refresh-token");
          const profile = await axios.get("/auth/profile");

          if (active) {
            useUserStore.setState({
              user: profile.data.user || profile.data,
              checkingAuth: false,
            });
          }
        } catch (refreshError) {
          if (active) {
            useUserStore.setState({ user: null, checkingAuth: false });
          }
        }
      }
    };

    restoreSession();

    const intervalId = window.setInterval(async () => {
      try {
        await axios.post("/auth/refresh-token");
      } catch (error) {
        useUserStore.setState({ user: null });
      }
    }, 14 * 60 * 1000);

    return () => {
      active = false;
      window.clearInterval(intervalId);
    };
  }, []);
};
